import * as DevConfigs from './dev'
import * as DevAndroidConfigs from './dev.android'
import * as StageConfigs from './stage'
import * as PreprodConfigs from './preprod'
import * as ProdConfigs from './prod'
import platform from 'helpers/platform'

interface EnvConfigs {
  api: {
    protocol: string
    host: string
    page: string
    fkpayHost: string
    upiServiceHost: string
  }
  isDev: boolean
  isStage: boolean
  isPreprod: boolean
  isProd: boolean
}

export const enum Environments {
  DEV = 'development',
  STAGE = 'stage',
  PREPROD = 'preprod',
  PROD = 'production',
}

let environment: Environments
let configs: EnvConfigs

switch (process.env.PROMO_ENV) {
  case 'development':
    // configs = await import(/* webpackChunkName: "dev" */ './dev')
    configs = platform.isAndroid ? DevAndroidConfigs : DevConfigs
    environment = Environments.DEV
    break
  case 'next1':
  case 'next2':
    configs = StageConfigs
    // configs = await import(/* webpackChunkName: "stage" */ './stage')
    environment = Environments.STAGE
    break
  case 'preprod':
    configs = PreprodConfigs
    // configs = await import(/* webpackChunkName: "preprod" */ './preprod')
    environment = Environments.PREPROD
    break
  default:
    configs = ProdConfigs
    environment = Environments.PROD
}

export { environment, configs }
